import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import {Contacts , LocationOn} from "@material-ui/icons";

import workStyle from "assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx";


import MapSection from "./MapSection.jsx";



class WorkSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem cs={12} sm={12} md={8}>
            <h2 className={classes.title}> Thank You for your interest in MGEC.</h2>
            <h3 className={classes.description}>
               We appreciate your feedback and strive to exceed your expectations.
               If you have any questions or comments about 
MGEC, one of our projects, or would like to schedule a consultation, please don’t hesitate to contact us.
            </h3>
              <br/>
              <br/>
              <br/>
              <br/>
              <h2 className={classes.title}><Contacts className={classes.icons} /> Contact Us <Contacts className={classes.icons} /></h2>

              
        
       <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
           <h2 className={classes.title}>Yangon</h2>

           <h5 className={classes.title}>
             587 Neikbanda St.,
             Nanthargone Ward ,
            Insein Township, Yangon 
                  Myanmar
              </h5>
              <h4 className={classes.title}>
               Tel: +959 255 656 100,
                <br />   &nbsp; &nbsp;  &nbsp;&nbsp;   +959 255 656 300,
                <br />  &nbsp;  &nbsp;  +959 534 3194
         
              </h4>
            </GridItem>
             <GridItem xs={12} sm={12} md={4}>
              <h2 className={classes.title}>Singapore </h2>
           <h5 className={classes.title}>
           10 Anson Road, #10-11
           International Plaza
            Singapore
          <br />
        
          <br />
          </h5>
          <h4 className={classes.title}>
          Tel: +659 793 3520
          </h4>
           </GridItem>

            <GridItem xs={12} sm={12} md={4}>
              <h2 className={classes.title}>
            Contact
            </h2>
            
            <h5 className={classes.title}>
            E-mail: enquiry@mgecsg.com <br/>
         

           
            </h5>
            </GridItem>
          </GridContainer>

          </GridItem>
        </GridContainer>
     
          <div>
            <h2 className={classes.title}><LocationOn className={classes.icons} />Find us at the office in Yangon</h2>
           <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
           
           <MapSection />
          </GridItem>
          </GridContainer>
       </div>
      </div>
    );
  }
}

export default withStyles(workStyle)(WorkSection);
 


// WEBPACK FOOTER //
// ./src/views/ContactPage/Sections/WorkSection.jsx